import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'

const Partner = ({ data }) => (
  <StaticQuery
    query={graphql`
      query { 
        fifthBeat: file(relativePath: {eq: "contents/loghi_IID_fifth-beat.jpg"}){
          childImageSharp{
            fluid (quality: 100){
              ...GatsbyImageSharpFluid
            }
          }
        }  
        usertestlab: file(relativePath: {eq: "contents/loghi_IID_usertestlab.jpg"}){
          childImageSharp{
            fluid (quality: 100){
              ...GatsbyImageSharpFluid
            }
          }
        }      
      }
    `}
    render={staticData => {
      const { title, partners } = data;
      const [fifthBeat, usertestlab] = partners;
      return (
        <section id="partner" className="section partner text-center" aria-labelledby="region-partner">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1">
                <h1 id="region-partner" className="section__title">{title}</h1>
                <div className="row">
                  <div className="col-sm-4 col-sm-offset-2">
                    <a href="http://fifthbeat.com/" title={fifthBeat.title} target="_blank" rel="noopener noreferrer" className="partner__logo text-center">
                      <Img fluid={staticData.fifthBeat.childImageSharp.fluid} alt={fifthBeat.title} className="partner__img" />
                      <span className="sponsor__name">{fifthBeat.title}</span>
                      <span className="sponsor__desc">{fifthBeat.desc}</span>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="http://usertestlab.it/" title={usertestlab.title} target="_blank" rel="noopener noreferrer" className="partner__logo text-center">
                      <Img fluid={staticData.usertestlab.childImageSharp.fluid} alt={usertestlab.title} className="partner__img" />
                      <span className="sponsor__name">{usertestlab.title}</span>
                      <span className="sponsor__desc">{usertestlab.desc}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
);

export default Partner;
